import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["qaFields", "docFields", "radio"]

  toggle() {
    const selected = this.radioTargets.find(r => r.checked)?.value
    if (selected === "qa") {
      this.qaFieldsTarget.classList.remove("hidden")
      this.docFieldsTarget.classList.add("hidden")
    } else {
      this.qaFieldsTarget.classList.add("hidden")
      this.docFieldsTarget.classList.remove("hidden")
    }
  }
}
